import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import VideoCameraBackOutlinedIcon from "@mui/icons-material/VideoCameraBackOutlined";
import { CircularProgress } from "@mui/material";
import React from "react";

import { FileSystemNodeType } from "@/shared/domain/files/filesystem/fileSystemNode";
import { isImage, isVideo } from "@/shared/domain/files/fileTypes";

interface RowTypeIconProps {
  isRowLoading: boolean;
  rowName: string;
  rowType: FileSystemNodeType;
}

export const RowTypeIcon: React.FC<RowTypeIconProps> = ({
  isRowLoading,
  rowName,
  rowType,
}) => {
  let iconContent;
  const progressIcon = <CircularProgress size={20} />;

  if (rowType === FileSystemNodeType.Directory) {
    return <FolderRoundedIcon color="info" />;
  }

  if (isImage(rowName)) {
    iconContent = isRowLoading ? (
      progressIcon
    ) : (
      <PhotoOutlinedIcon color="info" />
    );
  } else if (isVideo(rowName)) {
    iconContent = isRowLoading ? (
      progressIcon
    ) : (
      <VideoCameraBackOutlinedIcon color="info" />
    );
  } else {
    iconContent = isRowLoading ? (
      progressIcon
    ) : (
      <InsertDriveFileOutlinedIcon color="info" />
    );
  }

  return iconContent;
};
